module.exports = __webpack_public_path__ + "img/sangthai_logo.403885c4.png";